import { defineMessages } from '@jutro/locale';

export default defineMessages({
    Payments: {
        id: 'ml.claim.views.ml-claim-details-payments.Payments',
        defaultMessage: 'Payments'
    },
    noPaymentsText: {
        id: 'ml.claim.views.ml-claim-details-payments.There are no payments associated with this claim',
        defaultMessage: 'There are no payments associated with this claim.'
    },
    Date: {
        id: 'ml.claim.views.ml-claim-details-payments.Date',
        defaultMessage: 'Date'
    },
    CoverageType: {
        id: 'ml.claim.views.ml-claim-details-payments.Coverage Type',
        defaultMessage: 'Coverage Type'
    },
    AmountPaid: {
        id: 'ml.claim.views.ml-claim-details-payments.Amount Paid',
        defaultMessage: 'Amount Paid'
    },
    Total: {
        id: 'ml.claim.views.ml-claim-details-payments.Total',
        defaultMessage: 'Total'
    }
});
